import Script from 'next/script'
import { useEffect } from 'react'

type Props = {
  shouldLoad: boolean
}

const MedalliaIntegration = ({ shouldLoad }: Props) => {
  useEffect(() => {
    if (!window || !shouldLoad) return

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sdk = (window as any).KAMPYLE_ONSITE_SDK
    if (sdk && typeof sdk.updatePageView === 'function') {
      sdk.updatePageView()
    }
  }, [shouldLoad])

  if (!shouldLoad) {
    return null
  }

  return (
    <>
      <Script
        type="text/javascript"
        src="https://resources.digital-cloud-west.medallia.com/wdcwest/502718/onsite/embed.js"
        strategy="afterInteractive"
      />
    </>
  )
}

export default MedalliaIntegration
